import { createFileRoute } from '@tanstack/react-router';
import { AdminVerificationDetailPage } from '../../features/verification';

export const Route = createFileRoute('/admin/verification/$orgId')({
  component: function VerificationDetailRoute() {
    const { orgId } = Route.useParams();
    return <AdminVerificationDetailPage orgId={orgId} />;
  },
});
